module.exports = __webpack_public_path__ + "img/10-5.e48a7036.png";